/* eslint-disable */
<template>
<div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn v-can="{obj_type:'primary', action: 'edit'}" color="action" class="ml-2" @click.stop="addPrimary"><v-icon small class="pr-1">add_box</v-icon>strumento</v-btn>
                        </v-col>
                    </v-row>
                    <div v-if="advanced_search">
                    <v-divider />
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" v-if="!org_id && !filtered_org" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                    label="ente"
                                    v-model="filter.org"
                                    :items="orgs"
                                    item-value="_id"
                                    item-text="value.name"
                                    @change="changeOrgSelection"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                        <v-col cols="6" v-if="filter.org" class="d-flex justify-start align-content-middle ">
                            <v-autocomplete dense outlined
                                    label="strumenti"
                                    v-model="filter.availability"
                                    :items="primary_selection"
                                    item-value="value"
                                    item-text="label"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-divider v-if="lock_org" />
                    <v-row no-gutters>
                           <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="famiglia"
                                    v-model="filter.search_family"
                                    :items="families"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center pl-2">
                            <v-text-field dense outlined
                                label="seriale/marca/modello/certificato"
                                v-model="filter.search"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center">
                            <v-btn color="primary" class="d-flex align-content-center text-center pa-2" @click="search"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2 pa-2" @click="cancelSearch">annulla</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-4" />
                    </div>
                    
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                            <span><v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    @change="changeOrder"
                                    hide-details
                                ></v-autocomplete>
                            </span>
                            <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                        </v-col>
                    </v-row>
                    
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessuno strumento trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="(instr, _idx) in items" :key="instr._id">
                            <td>
                                <PrimaryItem
                                    :instrument_id="instr._id"
                                    instrument='instr'
                                    :key="instr._id + '_' + instr.value.updated"
                                    :organizations="orgs_dict"
                                    v-on:update_instrument="updatePrimary(instr._id, _idx)"
                                    v-on:add_instrument="updateSearch"
                                    @primary_removed="updateSearch"
                                    >
                                    <template v-slot:other_action>
                                        <span v-can="{obj_type:'organism', action: 'edit'}" :key="instr.value.used_by"><v-btn v-if="checkAway(instr)" color="primary" @click.stop="enableGiveBack(instr, _idx)" fab small><v-icon class="ma-2" small>undo</v-icon></v-btn>
                                        <v-btn v-else color="primary" @click.stop="enableLoan(instr, _idx)" fab small><v-icon :key="instr.value.updated" class="ma-2" small>send</v-icon></v-btn>
                                        </span>
                                    </template>
                                </PrimaryItem>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
            <div v-else>
                <v-card-text class="xs12 text-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </div>
        </BasicCard>
        <BaseDialog 
            :max_width="`600`"
            :dialog="loan_dialog.dialog"
            title="Presta strumento"
            v-on:close_dialog="cancel(loan_dialog)">
            <div class="d-flex align-baseline">
                <div class="d-flex">Presta strumento a</div>
                <v-autocomplete dense outlined
                    class="ml-4"
                    label="ente"
                    :items="orgs_filtered"
                    v-model="loan_dialog.used_by"
                    item-text="value.name"
                    item-value="_id"
                />
            </div>
            <div class="d-flex align-baseline justify-start">
                <v-textarea dense outlined
                    label="note prestito"
                    v-model="loan_dialog.note"
                />
            </div>
            
            <template v-slot:action>
                <div class="d-flex align-center justify-center my-4">
                    <v-btn :disabled="!loan_dialog.used_by" color="primary" @click="saveInstrument">salva</v-btn>
                    <v-btn class="ml-2" text @click="cancel(loan_dialog)">annulla</v-btn>
                </div>
            </template>        
        </BaseDialog>
        <BaseDialog 
            :max_width="`600`"
            :dialog="giveBack_dialog.dialog"
            title="Restituisci strumento"
            v-on:close_dialog="cancel(giveBack_dialog)">
            <div class="d-flex flex-column align-baseline">
                <div class="d-flex">Restituisci strumento</div>
                <div class="d-flex align-baseline justify-start">
                    <v-textarea dense outlined
                        label="note restituzione"
                        v-model="giveBack_dialog.note"
                    />
                </div>
            </div>
            <template v-slot:action>
                <div class="d-flex align-center justify-center my-4">
                    <v-btn color="primary" @click="giveBackInstrument">salva</v-btn>
                    <v-btn class="ml-2" text @click="cancel(giveBack_dialog)">annulla</v-btn>
                </div>
            </template>        
        </BaseDialog>
        <InstrumentDialog
            ref="instrumentEdit"
            org_id="filter.org"
            v-on:update_instrument="updateSearch"
        />

    </div>
</template>
<script>
// import _ from 'lodash'
import {ListManagement} from "../../utils/listMixin"
import InstrumentDialog from "../instruments/InstrumentDialog"
import BasicCard from '../../components/utils/Basic_card'
import BaseDialog from '../../components/dialogs/BaseDialog'
import PrimaryItem from "../instruments/PrimaryItem"
import {p_families} from "../../utils/common.js"
import {getModel} from '../../utils/model'
import {filterByOrg} from '../../utils/rolesManagement'

export default {
    components: {BasicCard, PrimaryItem, InstrumentDialog, BaseDialog},
    mixins: [ListManagement],
    props: {
        'org_id': {
            type: String,
            required: false,
            default: null
        },
        'lock_org': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data(){
        return {
            o_loading: true,
            instruments: [],
            expired: [],
            currentTime: null,
            value: '',
            org: "",
            orgs: [],
            orgs_filtered:[],
            loan_dialog: {
                dialog: false,
                o_item: null,
                used_by: '',
                note: ""
            },
            giveBack_dialog: {
                dialog: false,
                o_item: null,
                note: ''
            },
            families: Object.keys(p_families),
            filter: {
                org: '',
                availability: '',
                search_family: "",
                search: "",
            },
            db: 'registry',
            //sort_field_design: ['exp_date', 'updated', 'name', 'family'],
            sorting_fields: [
                {label: 'scadenza', value: ['value.exp_date', 'value.name'], order: ['asc', 'asc']},
                {label: 'modifica', value:['value.updated', 'value.name'], order: ['desc', 'asc']},
                {label: 'nome/codice cliente', value: ['value.name', 'value.exp_date'], order: ['asc', 'asc']},
                {label: 'famiglia', value: ['value.family', 'value.expire'], order: ['asc', 'asc']}
            ],
            sort_fields: {},
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            searching: false,
            primary_selection: [
                {label: 'tutti', value: 'all'},
                {label: 'a disposizione', value: 'used'},
                {label: 'proprietà', value: 'owner'},
                {label: 'in prestito da altri', value: 'loaned'},
                {label: 'prestati', value: 'unavail'}
            ],
            list_type: 'instrument'
        }
    },
    methods: {
        resetSearch(){
            this.filter = {
                org: this.org_id ? this.org_id : null,
                availability: this.primary_selection[0].value,
                search_family: "",
                search: "",
            }

            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
        async updateSearch() {
            this.searching = true
            var selectors = ['primary']
            if (this.filter.search_family){
                selectors.push(['family', this.filter.search_family])
            }
            if (this.filter.org) {
                selectors.push([this.filter.availability, this.filter.org])
            }
            let res = await this.searchFromDesignNew('primary/searchByData', 'all_keys', selectors, false)
            if (this.filter.search) {
                let text_res = await this.searchFromDesignNew('primary/searchByText', 'text', this.filter.search, false)
                let items = _.intersectionWith(res, text_res, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
                
                this.objects = this.orderBy(items, this.sort_fields)
            } else {
                this.objects = this.orderBy(res, this.sort_fields)
            }
            this.searching = false
        },
        changeOrgSelection() {
            if (!this.filter.availability) {
                this.filter.availability = this.primary_selection[0].value
            }
        },
        async updatePrimary(instr_id, idx) {
            console.log('UPDATE PRIMARY')
            let newInstr = await this.searchFromDesignNew('primary/searchByData', 'key', instr_id, false)
            console.log('****************UPDATE PRIMARY', newInstr[0])
            this.objects.splice(idx, 1, newInstr[0])
        },
        enableLoan(item, idx){
            this.loan_dialog.o_item = item
            this.loan_dialog.idx = idx
            this.loan_dialog.note = ""
            this.loan_dialog.dialog = true
            this.orgs_filtered = this.orgs.filter((element) => {
                console.log(element._id, item.org_id)
                if(element._id == item.value.org_id){
                    return false
                }
                return true
            })
            console.log("$$ orgs_filtered", this.orgs_filtered)
        },
        enableGiveBack(item, idx){
            this.giveBack_dialog.o_item = item
            this.giveBack_dialog.idx = idx
            this.giveBack_dialog.dialog = true
            this.giveBack_dialog.note = ""
        },
        async saveInstrument(){
            try {
                this.loan_dialog.o_item.used_by = this.loan_dialog.used_by
                let res = await this.updateInstrument(
                    this.loan_dialog.o_item._id,
                    {
                        'used_by': this.loan_dialog.used_by,
                        'note': this.loan_dialog.note
                    })
                //this.$set(this.loan_dialog.o_item, '_rev', res.rev)
                this.updateSearch()
                this.cancel(this.loan_dialog)
            } catch(error) {
                console.log('error', error)
            }
        },
        addPrimary(){
            this.$refs.instrumentEdit.openDialog({
                org_id: this.filter.org,
                owner_lock: this.owner_lock,
                primary: true
            })
        },
        async findOrgs(){
            let res = await this.searchFromDesignNew('registry/searchByData', 'key', "organism", false)
            this.orgs = this.orderBy(res, {value: ['value.name'], order: ['asc']})
                
            this.orgs_dict = _.keyBy(this.orgs, '_id')
        },
        cancel(dialog){
            dialog.o_item = null
            dialog.used_by = null
            dialog.dialog = false
        },
        async giveBackInstrument(){
            try {
                this.giveBack_dialog.o_item.value.used_by = this.giveBack_dialog.o_item.value.org_id
                let res = await this.updateInstrument(
                    this.giveBack_dialog.o_item._id, 
                    {
                        'used_by': this.giveBack_dialog.o_item.value.org_id,
                        'note': this.giveBack_dialog.note ? this.giveBack_dialog.note : 'restituzione'
                    })
                this.updateSearch()
                //this.$set(this.giveBack_dialog.o_item, '_rev', res.rev)
                this.cancel(this.giveBack_dialog)
            } catch(error) {
                console.log('error', error)
            }
        },
        checkAway(instrument){
            console.log("chekAWAY", instrument.value.used_by, instrument.value.org_id)
            if(instrument.value.used_by != instrument.value.org_id){
                return true
            } else {
                return false
            }
        },
        async updateInstrument(instr_id, fields) {
            console.log("ISNTRUMENT UPDATE", instr_id)
            let item = await this.$store.state.$pouch.get('registry', instr_id)
            console.log("ISNTRUMENT TO BE UPDATED", item)
            // merge fields and save instruemnt
            console.log("UPDATED INSTRUEMNT", item)
            item.used_by = fields.used_by
            item.updated_by = this.$store.state.user._id
            item.updated = (new Date()).getTime()
            let PrimaryLoanOp = getModel("PrimaryLoanOp");
            let loadObj = PrimaryLoanOp({
                instrument_id: instr_id,
                org_id: item.org_id,
                used_by: fields.used_by,
                note: fields.note,
                created_by: item.updated_by,
                created: item.updated
            })
            
            let docs_to_save = [item, loadObj]
            let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
            
            console.log(res)
            return res
        },
        initSelector() {
            if (this.lock_org){
                this.o_selector.org_id = this.org_id
                /*if (this.location_ids && this.location_ids.length>0){
                    this.o_selector.location_ids = {'$in': this.location_ids}
                }*/
            }
            this.o_selector.primary = true
        },
        customSelection(){
            // to be implemented with search
        },
    },
    async beforeMount(){
        this.currentTime = Date.now()
        let filter = this.restore_history_params()
        this.filtered_org = null
        if (filterByOrg('primary', 'view_org', this.$store.state.user.roles)) {
            this.filtered_org = this.$store.state.user.org_id
        }
        if (!filter) {
            this.resetSearch()
        } else if (this.org_id && filter.org != this.org_id) {
            this.resetSearch()
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
        }
        if (this.filtered_org) {
            this.filter.org = this.filtered_org
        }
        await this.findOrgs()
        await this.updateSearch()
        this.o_loading = false
    },
}
</script>